import AuthService from '@/services/auth-service';
import { errorResponseSchema } from '@/schemas/errorResponseSchema';
import { ApiError } from '@/constants/errorTypes';

export function createHeaders(): Headers {
  const accessToken = AuthService.getAccessToken();
  const headers = new Headers();

  headers.append('Content-Type', 'application/json');

  if (accessToken) {
    headers.append('ACCESS_TOKEN', accessToken);
  }

  return headers;
}

export async function handleResponse(response: Response): Promise<unknown> {
  if (!response.ok) {
    const responseData: unknown = await response.json();
    const errorParseResult = errorResponseSchema.safeParse(responseData);
    const errorData = errorParseResult.success ? errorParseResult.data : undefined;

    throw new ApiError(`HTTP ${response.status}: ${response.statusText}`, response.status, errorData);
  }
  return response.json();
}
